export var DEFAULT_FILTERS = {
    'status.Active': true
};
